import http from '@/extensions/http'
import { api_error, ENDPOINTS, localizedRouteName, ROUTES } from '@/helpers'
import router from '@/router'

export const auth = {
  state: {
    initiated: false,
    logged_in: false,
  },
  mutations: {
    setAuthInitiated(state, isInitiated = true) {
      state.initiated = isInitiated
    },
    updateLoggedIn(state, isLoggedIn = true) {
      state.logged_in = isLoggedIn
    },
  },
  actions: {
    async fetchHunter(context) {
      try {
        const { data } = await http.$get(ENDPOINTS.HUNTER.SHOW)
        await context.dispatch('setHunter', data)
        context.commit('updateLoggedIn')
      } catch ({ response }) {
        if (response) return api_error(response)
      }
    },
    async initAuth(context) {
      try {
        await http.$init()
        await context.dispatch('fetchHunter')
        if (context.state.logged_in) await context.dispatch('initRiddles')
      } catch ({ response }) {
        if (response) return api_error(response)
      }

      context.commit('setAuthInitiated')
    },
    async login(context, payload) {
      try {
        await http.$init()
        await http.$post(ENDPOINTS.AUTH.LOGIN, payload)
        await context.dispatch('updateHunterEmail', payload.email)
        await router.push({ name: localizedRouteName(ROUTES.AUTH.CONFIRMATION) })
      } catch ({ response }) {
        if (response) return api_error(response)
      }
    },
    async logout(context) {
      try {
        await http.$post(ENDPOINTS.AUTH.LOGOUT)
        context.commit('updateLoggedIn', false)
        http.csrf = false
      } catch ({ response }) {
        if (response) return api_error(response)
      }
    },
    async verify(context, payload) {
      try {
        const { data } = await http.$post(ENDPOINTS.AUTH.VERIFY, {
          ...payload,
          email: context.rootState.hunter.email,
        })
        await context.dispatch('setHunter', data)
        await context.dispatch('initRiddles')
        context.commit('updateLoggedIn')
        await router.push({ name: localizedRouteName(ROUTES.HUNT.WELCOME) })
      } catch ({ response }) {
        if (response) return api_error(response)
      }
    },
  },
}
